import { __decorate } from "tslib";
import ActionButton from '@/components/action_button/Index.vue';
import AppSegmentations from '@/components/v2/AppSegmentations';
import BaseSubtitle from '@/components/v2/BaseSubtitle';
import Paginator from '@/components/v2/Paginator.vue';
import CustomerSegmentationForm from '@/components/v2/CustomerSegmentationForm.vue';
import CustomerSegmentationMixin from '@/helpers/vue_mixins/v2/CustomerSegmentationMixin';
import PageTransition from '@/components/page_transition/Index.vue';
import SurveyRespondentSurveyResponse from '@/components/v2/SurveyRespondentSurveyResponse';
import BaseSearchInput from '@/components/v2/BaseSearchInput';
import PageTitle from '@/components/v2/PageTitle.vue';
import PaginatorMixin from '@/helpers/vue_mixins/v2/PaginatorMixin';
import RecipientsByCustomerSegmentation from '@/components/v2/RecipientsBySegmentation';
import SurveyRespondentDetailsCard from '@/components/v2/SurveyRespondentDetailsCard.vue';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { Bundle } from '@/helpers/entities/enums/v2/Bundle';
let CustomerSegmentation = class CustomerSegmentation extends mixins(CustomerSegmentationMixin, PaginatorMixin) {
    get bundle() {
        return Bundle.Survey;
    }
};
CustomerSegmentation = __decorate([
    Component({
        components: {
            AppSegmentations,
            ActionButton,
            BaseSearchInput,
            BaseSubtitle,
            CustomerSegmentationForm,
            PageTitle,
            Paginator,
            PageTransition,
            RecipientsByCustomerSegmentation,
            SurveyRespondentDetailsCard,
            SurveyRespondentSurveyResponse,
        },
    })
], CustomerSegmentation);
export default CustomerSegmentation;
